import React, { FC } from 'react'
import {
  IonLabel,
  IonIcon,
} from '@ionic/react';
import { closeCircle, filterOutline } from 'ionicons/icons';
import './FilterDropdown.scss'

interface ComponentProps {
	filter: any
	openFilter: (e: any) => void
	clearFilter: (e: any) => void
	clearFilterField: (e: any) => void
}

const FilterDropdown: FC<ComponentProps> = ({ filter, openFilter, clearFilter, clearFilterField }) => {
	return (
		<section 
			id="searchHeaderId" 
			slot="fixed"
			className="searchHeader box_shadow safe_padding_top">
				<section className="searchHeader__content searchHeader__content--controls">
					<button 
						onClick={openFilter}
						className="customButton"
						style={{ padding: '15px 20px', position: 'absolute', bottom: "0px" }}>
							Filter
							<IonIcon icon={filterOutline} />
					</button>
					<button 
						onClick={clearFilter}
						className="customButton customButton--clear"
						style={{ right: '15px', bottom: '0px' }}>
						Rensa Filter
					</button>
				</section>
				<section 
					className="searchHeader__content searchHeader__content--body">
						{ filter.place !== null ?
							<button
								className="filterChip"
								onClick={clearFilterField}
								id="place">
									<IonLabel>{filter.place}</IonLabel>
									<IonIcon icon={closeCircle} size="small"/>
							</button>
							: null
						}
						{ filter.searchRadius.isSet ?
							<button
								className="filterChip"
								onClick={clearFilterField}
								id="searchRadius">
									<IonLabel>{filter.searchRadius.value / 1000} km</IonLabel>
									<IonIcon icon={closeCircle} size="small"/>
							</button>
							: null
						}
						{ filter.time !== null ?
								<button
									id="time"
									onClick={clearFilterField}
									className="filterChip">
									<IonLabel>Kl. {filter.time}</IonLabel>
									<IonIcon icon={closeCircle} size="small"/>
								</button> 
							: null
						}
						{ filter.date !== null ?
								<button
									id="date"
									onClick={clearFilterField}
									className="filterChip">
									<IonLabel>{filter.date}</IonLabel>
									<IonIcon icon={closeCircle} size="small"/>
								</button> 
							: null
						}

				</section>
				{/* : null
				} */}

		</section>
	)
}
export default FilterDropdown